import { render, staticRenderFns } from "./PresentationEditorGoogleSlideComponent.vue?vue&type=template&id=4ac46c00&scoped=true&"
import script from "./PresentationEditorGoogleSlideComponent.vue?vue&type=script&lang=js&"
export * from "./PresentationEditorGoogleSlideComponent.vue?vue&type=script&lang=js&"
import style0 from "./PresentationEditorGoogleSlideComponent.vue?vue&type=style&index=0&id=4ac46c00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac46c00",
  null
  
)

export default component.exports